import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from '../../store/statsTabSlice.js';
import {
  tabsConfig,
  empty,
  rightSideConfig,
} from './statsTableConfig.js';
import { fetch } from './statsTableService.js';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';

import './Stats.css';
import customText from "../../components/components/custom_text/customText";

import StatsDataContainer from "./statsDataContainer";
import UserDataContainer  from "./usersDataContainer";
import TrainingsDataContainer  from "./trainingsDataContainer";

import GetStats from "./getStats";
import AddUser from "../users/addUser";

function Stats() {

  const dispatch = useDispatch(); 
  const activeTab = useSelector((state) => state.stats.activeTab);
  const currentPage = useSelector((state) => state.stats.currentPage);
  const sortBy = useSelector((state) => state.stats.sortBy);
  const sortDirection = useSelector((state) => state.stats.sortDirection);
  const checkedItems = useSelector((state) => state.stats.checkedItems);
  const keyword = useSelector((state) => state.stats.keyword);

  const getStatsOpen = useSelector((state) => state.stats.getStatsOpen);

  const needRefresh = useSelector((state) => state.stats.needRefresh);

  const [rows, setRows] = useState([]);
  const [trainingsTab1Opened, setTab1Opened] = useState(false);
  const [trainingsTab2Opened, setTab2Opened] = useState(false);


  const [statsData, setStatsData] = useState({
    usersStats: {
      registered: '0',
      unconfirmed: '0',
      active: '0',
      blocked: '0',
    },
    trainingsStats: {
      proposed: '0',
      completed: '0',
    },
    plansStats: {
      basic: '0',
      premium: '0',
    }
  });

  const [userData, setUserData] = useState({
    usersStats: {
      female: '0',
      male: '0',
      others: '0',
    },
    ageStats: {
      _16_18: '0',
      _19_25: '0',
      _26_35: '0',
      _36_45: '0',
      _46: '0',
    },
  });

  const [trainingsData, setTrainingsData] = useState({
    trainingsStats: {
      proposed: 0,
      training_rejected: 0,
      invitation_rejected: 0,
      ended: 0,
    },
    sports: {
      "Pierwsza mapa 1": 0,
      "Pierwsza mapa 2": 0,
      "Pierwsza mapa 3": 0,
      "Pierwsza mapa 4": 0,
      "Pierwsza mapa 5": 0,
      "Pierwsza mapa 6": 0,
      "Pierwsza mapa 7": 0,
      "Pierwsza mapa 8": 0,
    },
    rates: {
      "Druga mapa 1": 0.0,
      "Druga mapa 2": 0.0,
      "Druga mapa 3": 0.0,
      "Druga mapa 4": 0.0,
      "Druga mapa 5": 0.0,
      "Druga mapa 6": 0.0
    },
    avg_rate: 0
  });


  useEffect(() => {
    fetch(dispatch, setStatsData, setUserData, setTrainingsData);


  }, []);

  const x = [  {
    component: customText,
    props: {
      text: 'Zarejestrowani użytkownicy',
      placeholder: 'Wyszukaj',
      baseClass: 'custom-text'
    },
  },];






  return (
    <div>
      {getStatsOpen && <GetStats />}
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeTab, dispatch, setActiveTab)} buttons={rightSideConfig(needRefresh, dispatch)} />
        {activeTab === 'Statystyki ogólne' && <StatsDataContainer statsData={statsData} /> }
        {activeTab === 'Użytkownicy' && <UserDataContainer statsData={userData} /> }
        {activeTab === 'Treningi' && <TrainingsDataContainer statsData={trainingsData} tab1Opened={trainingsTab1Opened} setTab1Opened={setTab1Opened} tab2Opened={trainingsTab2Opened} setTab2Opened={setTab2Opened} /> }

      </Content>
    </div>
  );
}

export default Stats;